var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-image',{attrs:{"src":_vm.image,"fit":"contain"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }